import type { LayerKey } from '@festina-life/api'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../context/metaModelContext'
import {
  ALL_VERSIONS_VIEW_DATE,
  getApplicationViewGlMaps,
} from '../../workspace/helpers'
import { useOperationsContext } from '../../workspace/operationsContext'

/**
 * The GL maps that resolve at the given location. Defaults to every version, including
 * the ones that only start applying in the future, so that drafts are validated against
 * the whole history rather than against what the current view date happens to show.
 * Pass the view date to resolve what actually applies at it instead.
 */
export const useGlMapsForBlockAndLayer = ({
  layer,
  block,
  viewAt = ALL_VERSIONS_VIEW_DATE,
}: {
  layer: LayerKey
  block: string
  viewAt?: Date
}) => {
  const { glMapOperations } = useOperationsContext()
  const { layerTopology, blockTopology } = useMetaModelContext()

  return useMemo(
    () =>
      getApplicationViewGlMaps({
        glMapOperations,
        layer,
        block,
        layerTopology,
        blockTopology,
        viewAt,
      }),
    [glMapOperations, layer, block, layerTopology, blockTopology, viewAt],
  )
}
